<template>
  <v-form>
    <br />
    <v-card  :elevation="2" :disabled="desabilitado" outlined>
      <v-card-title>
        1. Marco estratégico
      </v-card-title>
      <v-card-text>
        <v-layout row wrap >
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0" >
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary" >Punto</label>
            <v-textarea  dense v-model="indicador.punto.nombre" :readonly="true" rows="1" outlined class="field-disabled">
            </v-textarea>
          </v-flex>
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary" >Pilar</label>
            <v-textarea dense v-model="indicador.pilar.nombre" :readonly="true" outlined rows="1" class="field-disabled">
            </v-textarea>
          </v-flex>
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Estrategia</label>
            <v-textarea dense v-model="indicador.estrategia.nombre" :readonly="true" outlined rows="1" class="field-disabled">
            </v-textarea>
          </v-flex>
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Línea de acción</label>
            <v-textarea dense v-model="indicador.linea.nombre" :readonly="true" outlined rows="1" class="field-disabled">
            </v-textarea>
          </v-flex>
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Producto</label>
            <v-textarea dense v-model="indicador.idproductoNavigation.nombre" :readonly="true" outlined rows="1" class="field-disabled">
            </v-textarea>
          </v-flex>
          <v-flex xs6 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Clasificador</label>
            <v-text-field dense v-model="indicador.idclasificacionNavigation.nombre" :readonly="true" outlined class="field-disabled">
            </v-text-field>
          </v-flex>

          <v-flex xs16 sm6 class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Instrumento de planeación</label>
            <v-select dense :items="gtiposclasificador" v-model="itemsclasificacion" item-text="nombre" :readonly="true" class="field-disabled"
              item-value="idtipoclasificador" outlined multiple compact append-icon=""></v-select>
          </v-flex>

          <v-flex xs12 sm6 v-show="permitenacional" class="col-padd pt-0 pb-0">
            <label class="tit-requerid">*</label><label class="v-label primary--text Label-primary">Plan Nacional</label>
            <v-select dense :items="gnacionales" v-model="indicador.idnacional" :readonly="true" append-icon="" class="field-disabled"
            item-text="nombre" item-value="idnacional" outlined density="compact"></v-select>
          </v-flex>

        </v-layout>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "indicador_basicos",
  data: function () {
    return {
      permitenacional: false,
      itemsclasificacion: null,
      indicador: null,
      sector: null,
      entidad: null,
      entidades: [],
      desabilitado: false, 
      loadclassification : false
    };
  },
  created() {
    if (this.gsectores.length == 0)
      this.get_sectores();

    this.itemsclasificacion = this.gficha_itemsclasificacion;
    this.indicador = this.gficha_indicador;
    if (this.indicador.entidades !== undefined) {

      let temp = this.gentidades.filter(
        (p) => p.identidad === this.indicador.entidades.identidad
      )[0];
      if (this.gsectores.length > 0)
        this.sector = this.gsectores.filter(
          (p) => p.idsector === temp.idsector
        )[0];
      this.entidad = temp;
    }
  },
  watch: {
    entidad: function () {
      this.indicador.entidades = this.entidad;
      this.set_indicador({ indicador: this.indicador });
    },
    sector: function () {
      if (this.sector != undefined)
        this.entidades = this.gentidades.filter(p => p.idsector === this.sector.idsector);
    }
    ,
    indicador: function () {
      this.set_indicador({ indicador: this.indicador });
    },
    itemsclasificacion: function () {
      if (this.itemsclasificacion.length > 0) {
        this.permitenacional = false;
        this.gtiposclasificador.forEach((element) => {
          let clasificadorFiltrado = this.itemsclasificacion.filter(function (params) {
            return params == element.idtipoclasificador;
          });
          if (clasificadorFiltrado.length > 0)
            if (element.manejanacional != null)
              if (element.manejanacional == true) {
                this.permitenacional = true;
              }
        });
      } else {
        this.permitenacional = false;
      }
      if (this.permitenacional == false && this.loadclassification) {
        if (this.indicador.idnacional != null) this.indicador.idnacional = null;
      }
      this.set_itemsclasificacion({
        itemsclasificacion: this.itemsclasificacion,
      });
    },
    gficha_indicador: function () {
      this.indicador = this.gficha_indicador;
      if (this.indicador.entidades !== undefined) {
        let temp = this.gentidades.filter(
          (p) => p.identidad === this.indicador.entidades.identidad
        )[0];
        this.sector = this.gsectores.filter(
          (p) => p.idsector === temp.idsector
        )[0];
        this.entidad = temp;
      }
    },
    gsectores: function () {
      let temp = this.entidad
      if (this.gsectores.length > 0) {
        if (temp != undefined)
          this.sector = this.gsectores.filter(
            (p) => p.idsector === temp.idsector
          )[0];
      }
    },
    gficha_itemsclasificacion: function () {
        this.loadclassification = true;
        this.itemsclasificacion = this.gficha_itemsclasificacion
    }
  },
  props: {
    administrar: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions([
      "get_sectores"
    ]),
    ...mapActions("fichatecnica/", [
      "set_permitenacional",
      "set_itemsclasificacion",
      "set_indicador"
    ]),
  },
  computed: {
    ...mapGetters([
      "gtiposclasificador",
      "gnacionales",
      "gentidades",
      "gsectores",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("fichatecnica", [
      "gficha_permitenacional",
      "gficha_itemsclasificacion",
      "gficha_indicador",
    ]),
  },
};
</script>
<style>
md1 .md-select-icon {
    display: none;
}
</style>